<template>
  <div class="main" v-loading="isLoading">
       <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="modelMenu" current="日报"  />
      <xy-toolbox-menu class="r"  >
          <xy-toolbox-menu-item icon="excel" @click="exportExcel">导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
   
    <div style="margin-top:20px;">
      <xy-toolbox-menu>
        <xy-toolbox-menu-item custom style="width:450px;">
          <div class="custom-content">
            <el-date-picker
              v-model="value2"
              type="daterange"
              align="right"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>

            <el-button style="margin-left:20px;" @click="getReport">生成报告</el-button>
          </div>
        </xy-toolbox-menu-item>

 

      </xy-toolbox-menu>
    </div>

    <div style="margin:auto;overflow: auto;" v-show="daliyReportList.length>0">
      <el-table
        border
        fit
        :data="daliyReportList"
        stripe
        tooltip-effect="dark"
        height="700"
        style="width:99.9%;white-space:nowrap;"
      >
        <el-table-column :label="item" :prop="item" v-for="(item, index) in columns" :key="index"></el-table-column>
        <!-- <el-table-column :label="item" :key="index" v-for="(item, index) in columns">
   
        </el-table-column>-->
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import Permissions from  '../../store/permissions.js'
import XLSX from "xlsx";
export default {
  name: "dailyreport",

  data() {
    return {
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "本月至今",
            onClick(picker) {
              const end = new Date();
              const _start = new Date();
              const start = new Date(
                _start.getFullYear(),
                _start.getMonth(),
                1
              );
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      value2: "",
      columns: []
    };
  },
  methods: {
    ...mapMutations("reports", ["setDaliyReportList"]),
    ...mapActions("reports", ["loadDaliyReport"]),
    getReport() {
      this.loadDaliyReport({ start: this.value2[0], end: this.value2[1] });
    },
    exportExcel() {
      // JSONToExcel(this.daliyReportList, "日报", "dayily_report");
     if(!Permissions.Client_ViewReport_Day_Down ())
            {
               this.$message({ message: "没有下载权限。", duration: 2000 });
               return ;
            }
      var worksheet = XLSX.utils.json_to_sheet(this.daliyReportList);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, worksheet, this. getNowFormatDate()+ "日报");
      XLSX.writeFile(new_workbook, this. getNowFormatDate()+"_report.xlsx");
    },
    getNowFormatDate() {
        var date = new Date();
        var seperator1 = "";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
  },

  computed: {
    ...mapGetters("reports", { daliyReportList: "daliyReportList" }),
    ...mapState({ isLoading: state => state.loadingCount > 0 })
  },
  watch: {
    daliyReportList(newValue) {
      this.columns.length = 0;
      for (var x in newValue[0]) {
        this.columns.push(x);
      }
    }
  }
};
</script>
<style .scoped>
.main .el-date-editor .el-range__icon {
  font-size: 14px;
  margin-left: 5px;
  color: #c0c4cc;
  float: left;
  line-height: 32px;
}
</style>